import { createSlice } from '@reduxjs/toolkit';

import { captureMeasurementPosition, captureSampleDetails, createSkuSampleMaterial, downloadTechPack, getSampleMaterial, uploadCaptureMeasurementPosition } from './api';

export const SampleManagementSlice = createSlice({

    name: 'SampleManagementPlatform',
    initialState: {
        isLoading: false,
        sampleData : [],
        error: '',
        createSkuMaterialSuccess: false,
        captureMeasurementPositionSuccess: false,
        uploadCaptureMeasurementSuccess: false,
        captureSampleDetailsSuccess: false,
        downloadTechPackSuccess: false
    },

    reducers: {
      clear: (state, action) => {
        return {
          ...state,
          [action.payload.key]: action.payload.value
        }
      }
    },

    extraReducers: (builder) => {
        builder.addCase(getSampleMaterial.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getSampleMaterial.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.sampleData = action.payload.data;
        })
        builder.addCase(getSampleMaterial.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(createSkuSampleMaterial.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(createSkuSampleMaterial.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.createSkuMaterialSuccess = true;
        })
        builder.addCase(createSkuSampleMaterial.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(captureMeasurementPosition.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(captureMeasurementPosition.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.captureMeasurementPositionSuccess = true;
        })
        builder.addCase(captureMeasurementPosition.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(captureSampleDetails.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(captureSampleDetails.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.captureSampleDetailsSuccess = true;
        })
        builder.addCase(captureSampleDetails.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(downloadTechPack.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(downloadTechPack.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.downloadTechPackSuccess = true;
        })
        builder.addCase(downloadTechPack.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(uploadCaptureMeasurementPosition.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(uploadCaptureMeasurementPosition.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.uploadCaptureMeasurementSuccess = true;
        })
        builder.addCase(uploadCaptureMeasurementPosition.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
    }
})

export const { clear } = SampleManagementSlice.actions


export default SampleManagementSlice.reducer